<div class="grid mb-4" *ngIf="type != 'worker_invoice_request'">
    <div class="col-3 input-field">
        <label for="workerId">Operario</label>
        <p-dropdown [options]="workers" [(ngModel)]="filters.workerId.value" optionLabel="name" optionValue="id" (onFilter)="onloadFilterWorkers($event)"
            [filter]="true" filterBy="name" appendTo="body" placeholder="Selecciona un operario" showClear (onclear)="loadWorkers(null)"></p-dropdown>
    </div>
    <div class="col-2 input-field">
        <label for="startDate">Desde</label>
        <p-calendar [firstDayOfWeek]="1" [(ngModel)]="filters.startDate.value" [showIcon]="true" [showButtonBar]="true" [monthNavigator]="true"
            [yearNavigator]="true" dateFormat="dd/mm/yy" d-form-field-error appendTo="body"></p-calendar>
    </div>
    <div class="col-2 input-field">
        <label for="endDate">Hasta</label>
        <p-calendar [firstDayOfWeek]="1" [(ngModel)]="filters.endDate.value" [showIcon]="true" [showButtonBar]="true" [monthNavigator]="true"
            [yearNavigator]="true" dateFormat="dd/mm/yy" d-form-field-error appendTo="body"></p-calendar>
    </div>
    <div class="col input-field">
        <label>&nbsp;</label>
        <div class="flex gap-2">
            <p-button label="Calcular conceptos" (click)="loadWorkerBillableItemLines(false)" />
            <p-button label="Limpiar" (click)="clearFilters()" />
        </div>
    </div>
</div>

<div *ngFor="let worker of workersWithItems" class="mb-4">
    <p-card styleClass="p-card-header-pb-0 p-card-content-pt-0 p-card-content-pb-0">
        <ng-template pTemplate="header">
            <div class="flex justify-content-between align-items-center">
                <div><b>{{ worker.name }}</b></div>
                <div>
                    <p-button label="Añadir a liquidación" icon="pi pi-plus" (click)="saveBillableItems(worker.id)" class="p-button-sm" />
                </div>
            </div>
        </ng-template>
        <div>
            <p-table [value]="getWorkerBillableItemLines(worker.id)">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Descripción</th>
                        <th width="100">Cantidad</th>
                        <th width="100">Precio</th>
                        <th width="100">Impuestos(%)</th>
                        <th width="100">Neto</th>
                        <th width="100">Total</th>
                        <th width="300"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                    <tr>
                        <td>{{ item.description }}</td>
                        <td>{{ item.quantity }}</td>
                        <td>
                            <div class="input-field">
                                <input pInputNumber [(ngModel)]="item.price" (ngModelChange)="onLineChange(item)" />
                            </div>
                        </td>
                        <td>{{ item.taxPercent | currency:'EUR':'symbol':'1.2-2' }}</td>
                        <td>{{ item.subtotal | currency:'EUR':'symbol':'1.2-2' }}</td>
                        <td>{{ item.total | currency:'EUR':'symbol':'1.2-2' }}</td>
                        <td>
                            <div class="flex gap-2">
                                <p-button *ngIf="item.workerBillableItemType?.code === 'DISTANCE'" label="Recalcular distancia" icon="pi pi-sync" (click)="refreshDistance(item)" class="p-button-text p-button-sm align-items-center"></p-button>
                                <p-button label="Info" icon="pi pi-info-circle" (click)="showInfo(item)" class="p-button-text p-button-sm align-items-center"></p-button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </p-card>
</div>

<div *ngIf="workersWithItems.length === 0" class="headerInfo">
    <p-messages severity="info" [closable]="false" >
        <ng-template pTemplate>
            No se han encontrado conceptos pendientes de facturar para el periodo indicado.
        </ng-template>
    </p-messages>
</div>

<p-dialog header="Detalle de cálculo" [(visible)]="displayInfoDialog" [modal]="true" [style]="{width: '50vw'}" appendTo="body">
    <div *ngIf="selectedLine" [innerHTML]="selectedLine.info" style="white-space: pre-wrap;">
    </div>
</p-dialog>